import { all, call, put, takeLatest } from "redux-saga/effects";
import { 
    getAdminBDMMetricsGroup,
    getAdminBDMMetricsOverview, 
    getAdminMetrics, 
    getAdminRAMetricsGroup, 
    getAdminRAMetricsOverview, 
    getAdminRecruiterMetricsGroup, 
    getAdminRecruiterMetricsOverview, 
    getAllUsers, 
    getBDMJobsMetrics, 
    getBDMMetrics, 
    getRAJobPostingMetrics, 
    getRAMetrics, 
    getRAMetricsGroup, 
    getRAMetricsOverview, 
    getRecruiterMetrics, 
    getRecruiterMetricsGroup 
} from "./atsDashboardApi.js";
import { 
    getAdminBDMMetricsGroupStart,
    getAdminBDMMetricsGroupSuccess,
    getAdminBDMMetricsOverviewStart,
    getAdminBDMMetricsOverviewSuccess,
    getAdminCompareMetricsStart,
    getAdminCompareMetricsSuccess,
    getAdminMetricsStart,
    getAdminMetricsSuccess,
    getAdminRAMetricsGroupStart,
    getAdminRAMetricsGroupSuccess,
    getAdminRAMetricsOverviewStart,
    getAdminRAMetricsOverviewSuccess,
    getAdminRecruiterMetricsGroupStart,
    getAdminRecruiterMetricsGroupSuccess,
    getAdminRecruiterMetricsOverviewStart,
    getAdminRecruiterMetricsOverviewSuccess,
    getAdminUsersStart,
    getBDMCompareMetricsStart,
    getBDMMetricsGroupStart, 
    getBDMMetricsOverviewStart, 
    getBDMMetricsStart, 
    getBDMRoleBasedMetricsStart, 
    getCompareMetricsSuccess, 
    getCompareTeamMetricsSuccess, 
    getMetricsFailure, 
    getMetricsGroupSuccess, 
    getMetricsOverviewSuccess, 
    getMetricsSuccess, 
    getRACompareMetricsStart, 
    getRAMetricsGroupStart, 
    getRAMetricsOverviewStart, 
    getRAMetricsStart, 
    getRARoleBasedMetricsStart, 
    getRecruiterCompareMetricsStart, 
    getRecruiterMetricsGroupStart, 
    getRecruiterMetricsOverviewStart, 
    getRecruiterMetricsStart, 
    getRecruiterRoleBasedMetricsStart, 
    getRoleBasedMetricsSuccess, 
    getTeamMetricsGroupSuccess, 
    getTeamMetricsOverviewSuccess, 
    getTeamMetricsSuccess,
    getTeamRoleBasedMetricsSuccess,
    revertStateLoading,
    setAdminBDMUsers,
    setAdminRAUsers,
    setAdminRecruiterUsers
} from "./atsDashboardSlice.js";

function* getRAMetricsData(params) {
    const actionValue = params.payload
    const isTeam = params.payload?.type;
    const isCompare = params.payload?.isCompare;

    try {
        const response = yield call(getRAMetrics, actionValue);
        if (response?.success) {
            if (isTeam) {
                if (isCompare) {
                    yield put(getCompareTeamMetricsSuccess(response?.data?.data || {}))
                } else {
                    yield put(getTeamMetricsSuccess(response?.data?.data || {}))
                }                
            } else {
                if (isCompare) {
                    yield put(getCompareMetricsSuccess(response?.data?.data || {}))
                } else {
                    yield put(getMetricsSuccess(response?.data?.data || {}));
                }
            }            
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getRAMetricsOverviewData(params) {
    const actionValue = params.payload;
    const isTeam = params.payload?.type;

    try {
        const response = yield call(getRAMetricsOverview, actionValue);
        if (response?.success) {
            if (isTeam) {
                yield put(getTeamMetricsOverviewSuccess(response?.data?.data || {}))
            } else {
               yield put(getMetricsOverviewSuccess(response?.data?.data || {}));
            }            
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getRARoleBasedMetricsData(params) {
    const actionValue = params.payload;
    const isTeam = params.payload?.type;

    try {
        const response = yield call(getRAJobPostingMetrics, actionValue);
        if (response?.success) {
            if (isTeam) {
                yield put(getTeamRoleBasedMetricsSuccess(response?.data?.data || {}))
            } else {
                yield put(getRoleBasedMetricsSuccess(response?.data?.data || {}));
            }            
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getRAMetricsGroupData(params) {
    const actionValue = params.payload;
    const isTeam = params.payload?.type;

    try {
        const response = yield call(getRAMetricsGroup, actionValue);
        if (response?.success) {
            if (isTeam) {
                yield put(getTeamMetricsGroupSuccess(response?.data?.data || {}))
            } else {
                yield put(getMetricsGroupSuccess(response?.data?.data || {}));
            }
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getBDMMetricsData(params) {
    const actionValue = params.payload;
    const isTeam = params.payload?.type;
    const isCompare = params.payload?.isCompare;

    try {
        const response = yield call(getBDMMetrics, actionValue);
        if (response?.success) {
            if (isTeam) {
                if (isCompare) {
                    yield put(getCompareTeamMetricsSuccess(response?.data?.data || {}))
                } else {
                    yield put(getTeamMetricsSuccess(response?.data?.data || {}))
                }
            } else {
                if (isCompare) {
                    yield put(getCompareMetricsSuccess(response?.data?.data || {}))
                } else {
                    yield put(getMetricsSuccess(response?.data?.data || {}));
                }
            }            
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getBDMMetricsOverviewData(params) {
    const actionValue = params.payload;
    const isTeam = params.payload?.type;

    try {
        const response = yield call(getBDMMetrics, actionValue);
        if (response?.success) {
            if (isTeam) {
                yield put(getTeamMetricsOverviewSuccess(response?.data?.data || {}))
            } else {
                yield put(getMetricsOverviewSuccess(response?.data?.data || {}));
            }
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getBDMRoleBasedMetricsData(params) {
    const actionValue = params.payload;
    const isTeam = params.payload?.type;

    try {
        const response = yield call(getBDMMetrics, actionValue);

        if (response?.success) {
            if (isTeam) {
                yield put(getTeamRoleBasedMetricsSuccess(response?.data?.data || {}))
            } else {
                yield put(getRoleBasedMetricsSuccess(response?.data?.data || {}));
            }            
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getBDMMetricsGroupData(params) {
    const actionValue = params.payload;
    const isTeam = params.payload?.type;

    try {
        const response = yield call(getBDMJobsMetrics, actionValue);
        if (response?.success) {
            if (isTeam) {
                yield put(getTeamMetricsGroupSuccess(response?.data?.data || {}))
            } else {
                yield put(getMetricsGroupSuccess(response?.data?.data || {}));
            }            
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getRecruiterMetricsData(params) {
    const actionValue = params.payload;
    const isTeam = params.payload?.type;
    const isCompare = params.payload?.isCompare;

    try {
        const response = yield call(getRecruiterMetrics, actionValue);
        if (response?.success) {
            if (isTeam) {
                if (isCompare) {
                    yield put(getCompareTeamMetricsSuccess(response?.data?.data || {}))
                } else {
                    yield put(getTeamMetricsSuccess(response?.data?.data || {}))
                }
            } else {
                if (isCompare) {
                    yield put(getCompareMetricsSuccess(response?.data?.data || {}))
                } else {
                    yield put(getMetricsSuccess(response?.data?.data || {}));
                }
            }            
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getRecruiterMetricsOverviewData(params) {
    const actionValue = params.payload;
    const isTeam = params.payload?.type;

    try {
        const response = yield call(getRecruiterMetrics, actionValue);
        if (response?.success) {
            if (isTeam) {
                yield put(getTeamMetricsOverviewSuccess(response?.data?.data || {}))
            } else {
                yield put(getMetricsOverviewSuccess(response?.data?.data || {}));
            }            
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getRecruiterRoleBasedMetricsData(params) {
    const actionValue = params.payload;
    const isTeam = params.payload?.type;

    try {
        const response = yield call(getRecruiterMetrics, actionValue);

        if (response?.success) {
            if (isTeam) {
                yield put(getTeamRoleBasedMetricsSuccess(response?.data?.data || {}))
            } else {
                yield put(getRoleBasedMetricsSuccess(response?.data?.data || {}));
            }            
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getRecruiterMetricsGroupData(params) {
    const actionValue = params.payload;
    const isTeam = params.payload?.type;

    try {
        const response = yield call(getRecruiterMetricsGroup, actionValue);
        if (response?.success) {
            if (isTeam) {
                yield put(getTeamMetricsGroupSuccess(response?.data?.data || {}))
            } else {
                yield put(getMetricsGroupSuccess(response?.data?.data || {}));
            }            
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getAdminMetricsOverviewData({ payload }) {
    const { role } = payload;

    const roleConfig = {
        RA: {
            api: getAdminRAMetricsOverview,
            successAction: getAdminRAMetricsOverviewSuccess
        },
        BDM: {
            api: getAdminBDMMetricsOverview,
            successAction: getAdminBDMMetricsOverviewSuccess
        },
        RECRUITER: {
            api: getAdminRecruiterMetricsOverview,
            successAction: getAdminRecruiterMetricsOverviewSuccess
        }
    };

    try {
        const config = roleConfig[role];
        if (!config) return;

        const response = yield call(config.api, payload);

        if (response?.success) {
            yield put(config.successAction(response?.data?.data || {}));
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    }
}

function* getAdminMetricsGroupData({ payload }) {
    const { role, type } = payload;

    const roleConfig = {
        RA: {
            api: getAdminRAMetricsGroup,
            groupSuccessAction: getAdminRAMetricsGroupSuccess,
            overviewSuccessAction: getAdminRAMetricsOverviewSuccess
        },
        BDM: {
            api: getAdminBDMMetricsGroup,
            groupSuccessAction: getAdminBDMMetricsGroupSuccess,
            overviewSuccessAction: getAdminBDMMetricsOverviewSuccess
        },
        RECRUITER: {
            api: getAdminRecruiterMetricsGroup,
            groupSuccessAction: getAdminRecruiterMetricsGroupSuccess,
            overviewSuccessAction: getAdminRecruiterMetricsOverviewSuccess
        }
    };

    try {
        const config = roleConfig[role];
        if (!config) return;

        const response = yield call(config.api, payload);

        if (response?.success) {
            if (type === "overview") {
                yield put(config.overviewSuccessAction(response?.data?.data || {}));
            } else {
                yield put(config.groupSuccessAction(response?.data?.data || {}));
            }
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getAdminMetricsData(params) {
    const actionValue = params.payload;
    const isCompare = params.payload?.isCompare;

    try {
        const response = yield call(getAdminMetrics, actionValue);
        if (response?.success) {      
            if (isCompare) {
                yield put(getAdminCompareMetricsSuccess(response?.data?.data || {}))
            } else {
                yield put(getAdminMetricsSuccess(response?.data?.data || {}))
            }   
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

function* getUsersData(params) {
    const actionValue = params.payload;

    try {
        const response = yield call(getAllUsers, actionValue);

        if (response?.success) {
            const usersData = response?.data?.data || [];
            const raUsers = usersData?.filter((user) => user?.role?.type === 2);
            const bdmUsers = usersData?.filter((user) => user?.role?.type === 3);
            const recruiterUsers = usersData?.filter((user) => user?.role?.type === 4);

            yield put(setAdminRAUsers(raUsers || []))
            yield put(setAdminBDMUsers(bdmUsers || []))
            yield put(setAdminRecruiterUsers(recruiterUsers || []))
        }
    } catch (error) {
        yield put(getMetricsFailure([]));
        console.error("Error fetching Dashboard Metrics:", error);
    } finally {
        yield put(revertStateLoading());
    }
}

export function* watchFetchAtsDashboard() {
    yield takeLatest(getRAMetricsStart.type, getRAMetricsData);
    yield takeLatest(getRAMetricsOverviewStart.type, getRAMetricsOverviewData);
    yield takeLatest(getRARoleBasedMetricsStart.type, getRARoleBasedMetricsData);
    yield takeLatest(getRAMetricsGroupStart.type, getRAMetricsGroupData);
    yield takeLatest(getRACompareMetricsStart.type, getRAMetricsData);
    yield takeLatest(getBDMMetricsStart.type, getBDMMetricsData);
    yield takeLatest(getBDMMetricsOverviewStart.type, getBDMMetricsOverviewData);
    yield takeLatest(getBDMRoleBasedMetricsStart.type, getBDMRoleBasedMetricsData);
    yield takeLatest(getBDMMetricsGroupStart.type, getBDMMetricsGroupData);
    yield takeLatest(getBDMCompareMetricsStart.type, getBDMMetricsData);

    yield takeLatest(getRecruiterMetricsStart.type, getRecruiterMetricsData);
    yield takeLatest(getRecruiterMetricsOverviewStart.type, getRecruiterMetricsOverviewData);
    yield takeLatest(getRecruiterRoleBasedMetricsStart.type, getRecruiterRoleBasedMetricsData);
    yield takeLatest(getRecruiterMetricsGroupStart.type, getRecruiterMetricsGroupData);
    yield takeLatest(getRecruiterCompareMetricsStart.type, getRecruiterMetricsData);

    yield takeLatest(getAdminRAMetricsOverviewStart.type, getAdminMetricsGroupData);
    yield takeLatest(getAdminBDMMetricsOverviewStart.type, getAdminMetricsGroupData);
    yield takeLatest(getAdminRecruiterMetricsOverviewStart.type, getAdminMetricsGroupData);
    yield takeLatest(getAdminRAMetricsGroupStart.type, getAdminMetricsGroupData);
    yield takeLatest(getAdminBDMMetricsGroupStart.type, getAdminMetricsGroupData);
    yield takeLatest(getAdminRecruiterMetricsGroupStart.type, getAdminMetricsGroupData);
    yield takeLatest(getAdminMetricsStart.type, getAdminMetricsData);
    yield takeLatest(getAdminCompareMetricsStart.type, getAdminMetricsData);
    yield takeLatest(getAdminUsersStart.type, getUsersData);
}